import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
var LEFT = "Left";
var RIGHT = "Right";
var UP = "Up";
var DOWN = "Down";
/* global document */

var defaultProps = {
  delta: 10,
  preventScrollOnSwipe: false,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true,
  swipeDuration: Infinity,
  touchEventOptions: {
    passive: true
  }
};
var initialState = {
  first: true,
  initial: [0, 0],
  start: 0,
  swiping: false,
  xy: [0, 0]
};
var mouseMove = "mousemove";
var mouseUp = "mouseup";
var touchEnd = "touchend";
var touchMove = "touchmove";
var touchStart = "touchstart";

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return RIGHT;
    }

    return LEFT;
  } else if (deltaY > 0) {
    return DOWN;
  }

  return UP;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    var isTouch = ("touches" in event); // if more than a single touch don't track, for now...

    if (isTouch && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse && !isTouch) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = isTouch ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      props.onTouchStartOrOnMouseDown && props.onTouchStartOrOnMouseDown({
        event: event
      });
      return Object.assign(Object.assign(Object.assign({}, state), initialState), {
        initial: xy.slice(),
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      var isTouch = ("touches" in event); // Discount a swipe if additional touches are present after
      // a swipe has started.

      if (isTouch && event.touches.length > 1) {
        return state;
      } // if swipe has exceeded duration stop tracking


      if (event.timeStamp - state.start > props.swipeDuration) {
        return state.swiping ? Object.assign(Object.assign({}, state), {
          swiping: false
        }) : state;
      }

      var _ref2 = isTouch ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          _rotateXYByAngle2 = _slicedToArray(_rotateXYByAngle, 2),
          x = _rotateXYByAngle2[0],
          y = _rotateXYByAngle2[1];

      var deltaX = x - state.xy[0];
      var deltaY = y - state.xy[1];
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
      var vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
      var dir = getDirection(absX, absY, deltaX, deltaY); // if swipe is under delta and we have not started to track a swipe: skip update

      var delta = typeof props.delta === "number" ? props.delta : props.delta[dir.toLowerCase()] || defaultProps.delta;
      if (absX < delta && absY < delta && !state.swiping) return state;
      var eventData = {
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        dir: dir,
        event: event,
        first: state.first,
        initial: state.initial,
        velocity: velocity,
        vxvy: vxvy
      }; // call onSwipeStart if present and is first swipe event

      eventData.first && props.onSwipeStart && props.onSwipeStart(eventData); // call onSwiping if present

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped".concat(dir)]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventScrollOnSwipe && props.trackTouch && event.cancelable) {
        event.preventDefault();
      }

      return Object.assign(Object.assign({}, state), {
        // first is now always false
        first: false,
        eventData: eventData,
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping && state.eventData) {
        // if swipe is less than duration fire swiped callbacks
        if (event.timeStamp - state.start < props.swipeDuration) {
          eventData = Object.assign(Object.assign({}, state.eventData), {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = props["onSwiped".concat(eventData.dir)];
          onSwipedDir && onSwipedDir(eventData);
        }
      } else {
        props.onTap && props.onTap({
          event: event
        });
      }

      props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({
        event: event
      });
      return Object.assign(Object.assign(Object.assign({}, state), initialState), {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };
  /**
   * The value of passive on touchMove depends on `preventScrollOnSwipe`:
   * - true => { passive: false }
   * - false => { passive: true } // Default
   *
   * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
   *
   * props.touchEventOptions can also be set for all touch event listeners,
   * but for `touchmove` specifically when `preventScrollOnSwipe` it will
   * supersede and force passive to false.
   *
   */


  var attachTouch = function attachTouch(el, props) {
    var cleanup = function cleanup() {};

    if (el && el.addEventListener) {
      var baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions); // attach touch event listeners and handlers

      var tls = [[touchStart, onStart, baseOptions], // preventScrollOnSwipe option supersedes touchEventOptions.passive
      [touchMove, onMove, Object.assign(Object.assign({}, baseOptions), props.preventScrollOnSwipe ? {
        passive: false
      } : {})], [touchEnd, onEnd, baseOptions]];
      tls.forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 3),
            e = _ref4[0],
            h = _ref4[1],
            o = _ref4[2];

        return el.addEventListener(e, h, o);
      }); // return properly scoped cleanup method for removing listeners, options not required

      cleanup = function cleanup() {
        return tls.forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              e = _ref6[0],
              h = _ref6[1];

          return el.removeEventListener(e, h);
        });
      };
    }

    return cleanup;
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = void 0;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el, props);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return Object.assign(Object.assign(Object.assign({}, state), {
        el: el
      }), addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef
  }; // if track mouse attach mouse down listener

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, previousProps, attachTouch) {
  // if trackTouch is off or there is no el, then remove handlers if necessary and exit
  if (!props.trackTouch || !state.el) {
    if (state.cleanUpTouch) {
      state.cleanUpTouch();
    }

    return Object.assign(Object.assign({}, state), {
      cleanUpTouch: undefined
    });
  } // trackTouch is on, so if there are no handlers attached, attach them and exit


  if (!state.cleanUpTouch) {
    return Object.assign(Object.assign({}, state), {
      cleanUpTouch: attachTouch(state.el, props)
    });
  } // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
  // remove and reattach handlers (this is required to update the passive option when attaching
  // the handlers)


  if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe || props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
    state.cleanUpTouch();
    return Object.assign(Object.assign({}, state), {
      cleanUpTouch: attachTouch(state.el, props)
    });
  }

  return state;
}

function useSwipeable(options) {
  var trackMouse = options.trackMouse;
  var transientState = React.useRef(Object.assign({}, initialState));
  var transientProps = React.useRef(Object.assign({}, defaultProps)); // track previous rendered props

  var previousProps = React.useRef(Object.assign({}, transientProps.current));
  previousProps.current = Object.assign({}, transientProps.current); // update current render props & defaults

  transientProps.current = Object.assign(Object.assign({}, defaultProps), options); // Force defaults for config properties

  var defaultKey;

  for (defaultKey in defaultProps) {
    if (transientProps.current[defaultKey] === void 0) {
      transientProps.current[defaultKey] = defaultProps[defaultKey];
    }
  }

  var _React$useMemo = React.useMemo(function () {
    return getHandlers(function (stateSetter) {
      return transientState.current = stateSetter(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      handlers = _React$useMemo2[0],
      attachTouch = _React$useMemo2[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
  return handlers;
}

export { DOWN, LEFT, RIGHT, UP, useSwipeable };